<div class="gamejr-container">
  <div class="header">
    <h4>{{ noteType === 'private' ? 'PRIVATE NOTE' : 'PUBLIC NOTE' }}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeForm()">
      <img src="assets/icons/icon-close.svg" alt="">
    </button>
  </div>

  <form [formGroup]="privateNoteForm" (ngSubmit)="createNote()">
    <div class="add-gtop">
      <textarea class="text-area" name="note" formControlName="note"
        [placeholder]="'Enter your ' + noteType + ' note...'" (keydown.enter)="$event.preventDefault()"
        #noteTextarea>
      </textarea>
      @if (privateNoteForm.get('note').touched && privateNoteForm.get('note').hasError('required')) {
        <div
          class="error-message">
          Please Enter Note
        </div>
      }
    </div>
    <div class="btn-sec">
      <button class="btn btn-green" type="submit">Create</button>
    </div>
  </form>
</div>